import { PALS, CORN, ENGLISH_FONTS, BENGALI_FONTS } from "@/data/constants";

const UI_KEY = "bp_ui";
export const DEFAULT_UI = { pal: "pulse", mode: "dark", corner: "soft", latinFont: "sans", bengaliFont: "hind" };

export function applyTheme(ui) {
  const u = { ...DEFAULT_UI, ...(ui || {}) };
  const p = PALS.find((x) => x.id === u.pal) || PALS[0];
  const dark = u.mode === "dark" || (u.mode === "auto" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  const c = dark ? p.D : p.L;
  const r = CORN[u.corner] || CORN.soft;
  const legacy = u.font && ENGLISH_FONTS[u.font] ? u.font : "sans";
  const latin = (ENGLISH_FONTS[u.latinFont || legacy] || ENGLISH_FONTS.sans)[1];
  const bengali = (BENGALI_FONTS[u.bengaliFont] || BENGALI_FONTS.hind)[1];
  const R = document.documentElement;
  const vars = {
    "--ac": c[0], "--bg": c[1], "--card": c[2], "--bd": c[3], "--tx": c[4], "--mu": c[5],
    "--g1": p.g[0], "--g2": p.g[1], "--on": dark ? "#04101c" : "#ffffff",
    "--sh": dark ? "0 1px 0 rgba(255,255,255,.03), 0 10px 30px -18px rgba(0,0,0,.6)" : "0 1px 2px rgba(20,32,43,.04), 0 8px 24px -12px rgba(20,32,43,.12)",
    "--dg": dark ? "#f87171" : "#dc2626", "--ok": dark ? "#4ade80" : "#16a34a", "--wn": dark ? "#fbbf24" : "#d97706",
    "--nec": dark ? "#60a5fa" : "#2563eb", "--unn": dark ? "#f87171" : "#dc2626",
    "--r": r[0], "--ri": r[1], "--latin": latin, "--bengali": bengali,
    "--active-font": document.documentElement.lang === "bn" ? bengali : latin,
    "--body": `var(--active-font), system-ui, -apple-system, sans-serif`,
  };
  Object.entries(vars).forEach(([k, v]) => R.style.setProperty(k, v));
  R.classList.toggle("dark", dark);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", c[1]);
  try { localStorage.setItem(UI_KEY, JSON.stringify(u)); } catch (e) { /* storage full */ }
}

export const cachedUi = () => {
  try { return JSON.parse(localStorage.getItem(UI_KEY) || "null"); } catch (e) { return null; }
};
